var _excluded = ["label", "error", "emptyLabel", "className", "options", "truncate"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useState } from 'react';
import { apricot } from '../../profile';
import Label from './Label';
export default React.forwardRef(function (_ref, ref) {
  var label = _ref.label,
      error = _ref.error,
      _ref$emptyLabel = _ref.emptyLabel,
      emptyLabel = _ref$emptyLabel === void 0 ? 'Choose...' : _ref$emptyLabel,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      options = _ref.options,
      _ref$truncate = _ref.truncate,
      truncate = _ref$truncate === void 0 ? 50 : _ref$truncate,
      input = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      focused = _useState2[0],
      setFocus = _useState2[1];

  var _ref2 = options.find(function (o) {
    return o.value == input.value;
  }) || {},
      _ref2$label = _ref2.label,
      selectedLabel = _ref2$label === void 0 ? '' : _ref2$label;

  var errId = error ? "errMessage-".concat(input.name) : null;
  var renderedLabel = selectedLabel.length > truncate ? apricot().utils.textTruncate(selectedLabel, truncate, 'last', '...') : selectedLabel;

  var onFocusHandler = function onFocusHandler(e) {
    setFocus(true);
    if (input.onFocus) input.onFocus(e);
  };

  var onBlurHandler = function onBlurHandler(e) {
    setFocus(false);
    if (input.onBlur) input.onBlur(e);
  };

  return /*#__PURE__*/React.createElement("div", {
    className: "form-group ".concat(className, " ").concat(error ? 'has-error' : '')
  }, /*#__PURE__*/React.createElement(Label, {
    label: label,
    id: input.name,
    required: input.required
  }), /*#__PURE__*/React.createElement("div", {
    className: "cb-select-container"
  }, /*#__PURE__*/React.createElement("select", _extends({}, input, {
    id: input.name,
    className: "form-control replaced",
    onFocus: onFocusHandler,
    onBlur: onBlurHandler,
    "aria-describedby": errId,
    ref: ref
  }), emptyLabel ? /*#__PURE__*/React.createElement("option", {
    value: ""
  }, emptyLabel) : null, options.map(function (c) {
    return /*#__PURE__*/React.createElement("option", {
      value: c.value,
      key: c.value
    }, c.label);
  })), /*#__PURE__*/React.createElement("span", {
    className: "cb-select ".concat(focused ? 'focus' : '', " ").concat(input.disabled ? 'disabled' : ''),
    "aria-hidden": input.disabled
  }, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
    className: "cb-select-arrow"
  }), renderedLabel || emptyLabel)))), error ? /*#__PURE__*/React.createElement("p", {
    tabIndex: "-1",
    id: errId,
    className: "cb-error-msg",
    role: "alert"
  }, error) : null);
});